module.exports = __webpack_public_path__ + "static/media/04.Ganesha Aradhane.e659cceb.jpg";